import React, { Component } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import me from "../me2.jpg";

export default class ProfileSection extends Component {
	render() {
		return (
			<section>
				<Container>
					<Row>
						<Col xs={12} md={6} className="mb-2">
							<img
								src={me}
								className="profilePicture m-auto"
								alt="profilePicture"
							/>
						</Col>
						<Col xs={12} md={6} className="align-self-center">
							<h3 className="m-auto">Ersoy Efe Uruk</h3>
							<h3 className="m-auto pt-2">Software Engineer</h3>
						</Col>
					</Row>
					<Row className="intro">
						<Col className="justify-content-md-center">
							<p className="animate">
								Hello, I'm Ersoy Efe Uruk. I love working on Web
								and Mobile Projects. Nowadays, I'm mostly
								working on Frontend Development.
							</p>
						</Col>
					</Row>
					<Row className="mt-2">
						<Col>
							<Button
								href="#contact"
								style={{ fontSize: "calc(10px + 1vmin)" }}
							>
								Discuss A Project &gt;
							</Button>
						</Col>
					</Row>
				</Container>
			</section>
		);
	}
}
